document.getElementById('video-cover').addEventListener('click', function() {
    var coverImage = document.getElementById('video-cover');
    var video = document.getElementById('desktop-video');
    
    // Hide the image and show the video
    coverImage.style.display = 'none';
    video.style.display = 'block';

    // Play the video
    video.play();
});